import { reactive } from 'vue';

// Dialogs of the Vue chrome, rendered once by AppChrome and opened from its bars, menus and panels
// (the panels live in menus and bottom sheets that close before the dialog opens).
const dialogs = reactive({ profile: false, releaseNotes: false, support: false, draftCarts: false, imageKey: null });

export const useChromeDialogs = () => dialogs;

export function openChromeDialog(name) {
	if (typeof dialogs[name] === 'boolean') dialogs[name] = true;
}

export function openProductImage(key) {
	dialogs.imageKey = key;
}

export function closeChromeDialogs() {
	Object.keys(dialogs).forEach((name) => (dialogs[name] = typeof dialogs[name] === 'boolean' ? false : null));
}
